exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sideBarContainer {\n  background-color: #f7f7f7;\n  border-right: 1px solid #d7e0e6;\n  width: 100%;\n  height: 100%;\n}\n.sideBarContainer > ul {\n  background-color: #f7f7f7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"importLoaders":1}!./src/app/sidebar/style.less
// module id = 337
// module chunks = 7